var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full p-20 bg-gray-10"},[_c('div',[_c('h1',{staticClass:"text-h32 mb-20"},[_vm._v(" Switch 开关 ")]),_c('div',[_c('div',{staticClass:"mb-20"},[_c('a-switch',{attrs:{"default-checked":""},on:{"change":_vm.onChange}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }